import React from 'react';
import {Form} from 'react-bootstrap';
import {useSelector} from 'react-redux';
import FilterItem from './FilterItem';
import TriangleIcon from '../../assets/images/triangle.png';
import {GetFilterTranslationText} from '../../components/TranslationLabel';
import Accordion from 'react-bootstrap/Accordion';
import CustomToggle from '../../elements/Accordion/CustomToggle';
import '../../styles/Accordion.scss';

function FilterGroup({onToggleFilter, eventKey, label, field, program_num, icon}) {
  const translations = useSelector(state => state.translations.value);

  const translatedLabel = GetFilterTranslationText(translations, label, 'No Label');

  const items = translations.VariableLabel.filter(t => t.trans_lang_program_num === program_num);

  const categoryId = items[0]?.trans_lang_program_num;
  const categoryFilterCount = useSelector(state => state.showFilters.filterCount[categoryId]);
    //defaultActiveKey={countryFilterOpened ? 1 : null}
  return (
      <>
          
         <Accordion.Item eventKey={eventKey} >
        <Accordion.Header className="bold d-flex flex-row align-items-center ">
          <CustomToggle
            eventKey={eventKey}
            content={{
              filterCount: categoryFilterCount,
              header: translatedLabel,
              icon_one: icon,
              icon_two: TriangleIcon,
            }}
            isOpen={false}
          />
        </Accordion.Header>
              <Accordion.Body className="p-0" >
          {FilterForm(onToggleFilter, translatedLabel, field, items)}
        </Accordion.Body>
      </Accordion.Item>
    </>
  );
}

const FilterForm = (onToggleFilter, header, field, items) => {    
  return (
    <Form className="p-4">
      {items.map((itm, index) => (
          <FilterItem
              key={index}
              header={header}
              field={field}
              sub_filter_text={itm.trans_lang_variable_text}
              categoryId={itm.trans_lang_program_num}
              trans_lang_variable_value={itm.trans_lang_variable_value}
              trans_key={itm.trans_lang_variable_key}
              onToggleFilter={onToggleFilter}
              
        />
      ))}
    </Form>
  );
};

export default FilterGroup;
